// Every named route resolves through the active i18n locale.
export const pageTitleKeys = {
  contact: 'contact.title',
  "login": "login.title",
  "register": "register.title",
  "forgotPassword": "forgotPassword.title",
  "market": "appShell.pages.market",
  "platform": "appShell.pages.platform",
  "manyEmpty": "appShell.pages.manyEmpty",
  "whale": "appShell.pages.whale",
  "burst": "appShell.pages.burst",
  "calendar": "appShell.pages.calendar",
  "burstHeatmapDetails": "appShell.pages.burstHeatmapDetails",
  "burstCoinStatisticsDetails": "appShell.pages.burstCoinStatisticsDetails",
  "hyperliquid": "appShell.pages.hyperliquid",
  "hyperliquidDetails": "appShell.pages.hyperliquidDetails",
  "rate": "appShell.pages.rate",
  "application": "appShell.pages.application",
  "publicChain": "appShell.pages.publicChain",
  "newChain": "appShell.pages.newChain",
  "inscription": "appShell.pages.inscription",
  "consult": "appShell.pages.consult",
  "solswap": "appShell.pages.solswap",
  "my": "appShell.pages.my",
  "signIn": "appShell.pages.signIn",
  "signInRecord": "signInRecord.title",
  "contractCheck": "appShell.pages.contractCheck",
  "withdrawal": "withdrawal.title",
  "withdrawalRecord": "withdrawalRecord.title",
  "invite": "invite.title",
  "bindingApi": "bindingApi.title",
  "hitNewRobot": "hitNewRobot.title",
  "userHitNewRobotInfo": "appShell.pages.userHitNewRobotInfo",
  "hitNewRobotRule": "hitNewRobotRule.title",
  "collect": "collect.title",
  "trace": "trace.title",
  "userDelete": "userDelete.title",
  "team": "team.title",
  "forum": "forum.title",
  "forumPublish": "forum.publishTitle",
  "forumDetails": "forum.detailsTitle",
  "tool": "tool.title",
  "toolCompanyHoldings": "toolCompanyHoldings.title",
  "toolSentimentIndex": "toolSentimentIndex.title",
  "toolMTGoxMonitor": "toolMTGoxMonitor.title",
  "toolOutsidePrice": "toolOutsidePrice.title",
  "toolOutsideDisk": "toolOutsideDisk.title",
  "toolLargeIncrease": "toolLargeIncrease.title",
  "toolLargeDecrease": "toolLargeDecrease.title",
  "toolStableCoin": "toolStableCoin.title",
  "toolBlockChainBrowser": "toolBlockChainBrowser.title",
  "externalLink": "appShell.externalLink",
  "calendarDetail": "appShell.pages.calendarDetail",
  "consultDetails": "appShell.pages.consultDetails",
  "coinDetails": "coinDetails.title",
  "newCoinDetails": "appShell.pages.newCoinDetails",
  "platformDetails": "platformDetails.title",
  "insdetail": "insdetail.title",
  "firmOffer": "firmOffer.title"
};
